import { render, staticRenderFns } from "./chatIA.vue?vue&type=template&id=5008bd98&scoped=true"
import script from "./chatIA.vue?vue&type=script&lang=js"
export * from "./chatIA.vue?vue&type=script&lang=js"
import style0 from "./chatIA.vue?vue&type=style&index=0&id=5008bd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008bd98",
  null
  
)

export default component.exports